import estadosMunicipios from "./mexicoEstados.json";

// Lista ordenada alfabéticamente de las 32 entidades federativas.
export const ENTIDADES = Object.keys(estadosMunicipios).sort((a, b) =>
  a.localeCompare(b, "es")
);

export function municipiosDe(entidad) {
  if (!entidad) return [];
  const arr = estadosMunicipios[entidad] || [];
  return [...arr].sort((a, b) => a.localeCompare(b, "es"));
}
